module.exports = __webpack_public_path__ + "img/44.6067207c.png";